module.exports = __webpack_public_path__ + "static/05-b5eabc5c9aae59683de1eeee2b48c0a6.jpg";